<template>
  <SideModal
    :title="title"
    @close="$emit('close')"
    :show="true"
    class="acknowledge__modal"
    @go-back="$emit('close')"
  >
    <template v-slot:content>
      <form
        @submit.prevent="validateForm = true"
        class="tw-max-w-[334px] tw-mx-auto tw-mt-14"
      >
        <p class="tw-text-sm tw-tracking-[-0.12px] tw-text-[#323E67]">
          Address Information
        </p>
        <InputField
          label="Enter Address"
          :validate="validateForm"
          class="tw-mb-6 tw-mt-2"
          type="text"
          name="officeAddress"
          :currentValue="info.officeAddress"
          @input-changed="storeValue"
          @is-valid="handleValidation"
        />
        <Dropdown
          class="tw-mb-4"
          name="country"
          label="Select Country"
          :validate="validateForm"
          :currentValue="country"
          :options="countryList"
          @input-changed="storeValue"
          @is-valid="handleValidation"
        />
        <Dropdown
          name="state"
          label="Select State"
          :validate="validateForm"
          :currentValue="info.state"
          :options="stateList"
          @input-changed="storeValue"
          @is-valid="handleValidation"
        />
        <div class="tw-w-40 tw-ml-auto">
          <CustomButton title="Submit" class="tw-mt-10" />
        </div>
      </form>
    </template>
  </SideModal>
</template>

<script>
  import SideModal from "@/components/general/sidemodal/SideModal";
  import InputField from "@/components/general/InputField";
  import Dropdown from "@/components/general/Dropdown";
  import countryRegionData from "@/utils/js/countryRegionData.js";
  import countryCode from "@/utils/json/countryCode.json";
  import CustomButton from "@/components/general/BtnComponent";
  import { mapActions, mapGetters } from "vuex";
  export default {
    data() {
      return {
        title: "Edit Company Information",
        countryRegionData,
        countryCode,
        stateList: [],
        validateForm: false,
        validationResult: [],
        info: {
          country: "",
          officeAddress: "",
          country: "",
          state: "",
        },
        country: "",
      };
    },
    components: {
      SideModal,
      CustomButton,
      InputField,
      Dropdown,
    },
    watch: {
      "info.country"(val) {
        //if country and orgInfo.country are not the same
        if (!this.country.includes(val)) {
          //filter list of countries by code
          const filteredCountry = this.countryCode.countries.filter(
            (country) => country.code === val
          );
          //if result is not empty, concatenate value and assign to country
          if (filteredCountry.length > 0) {
            const countryConcat = `${filteredCountry[0].name} ${filteredCountry[0].flag} - ${filteredCountry[0].code}`;
            this.country = countryConcat;
          }
        }
      },
      country(val) {
        const value = val?.split(" ");
        if (value) {
          this.info.country = value[value.length - 1];
          this.getStates(val);
        }
      },
      validateForm(val) {
        if (!val) {
          setTimeout(() => {
            this.validateForm = false;
          }, 1000);
        }
      },
      validationResult: {
        deep: true,
        handler(val) {
          if (
            val.length >= Object.keys(this.info).length &&
            !val.includes(false)
          ) {
            this.updateCompanyInfo();
          }
        },
      },
    },
    computed: {
      ...mapGetters("organisationModule", ["organisationDetails"]),
      countryList() {
        const countryList = this.countryCode.countries.map((country) => {
          return `${country.name} ${country.flag} - ${country.code}`;
        });
        return countryList;
      },
    },
    mounted() {
      this.info.officeAddress = this.organisationDetails.officeAddress;
      this.info.country = this.organisationDetails.country;
      this.info.state = this.organisationDetails.state;
    },
    methods: {
      ...mapActions(["showToast", "setLoading"]),
      ...mapActions("organisationModule", ["updateOrgDetails"]),
      getStates(country) {
        this.countryRegionData.map((countryData) => {
          if (
            country.includes(countryData.countryName) ||
            country.includes(countryData.countryShortCode)
          ) {
            this.stateList = countryData.regions.map((state) => {
              return state.name;
            });
          }
        });
      },
      storeValue(object) {
        if (object.name !== "country") {
          this.info[object.name] = object.value;
        } else {
          this[object.name] = object.value;
        }
      },
      handleValidation(value) {
        this.validationResult.push(value);
      },
      async updateCompanyInfo() {
        const data = this.info;
        try {
          const response = await this.updateOrgDetails(data);
          const { message } = response.data;
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          this.$emit("info-updated");
          this.$emit("close");
        } catch (error) {
          return error;
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
